import styled from 'styled-components'
import { Button } from '../ui'

export const BtnsWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	@media (max-width: 700px) {
		margin: 0 10px;
		width: auto;
	}
`

export const AddButton = styled(Button)`
	background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
	border: 2px solid #6366f1;
	border-radius: 22px;
	color: white;
	transition: all 0.3s ease;
	box-shadow: 0px 4px 15px rgba(99, 102, 241, 0.3);
	
	&:hover {
		background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
		transform: translateY(-1px);
		box-shadow: 0px 6px 20px rgba(99, 102, 241, 0.4);
	}
	
	@media (max-width: 700px) {
		padding: 0;
		height: 42px;
		width: 42px;
		border-radius: 50%;
		box-shadow: 0px 4px 12px rgba(99, 102, 241, 0.3);
		font-size: 18px;
	}
`

export const LinksWrapper = styled.div`
	display: flex;
	flex-flow: row;
`
